import React from "react";
import { Link, Outlet } from "react-router-dom";
// import "../../../css/admin.module.css";

const CourseManagement = () => {
    return (
        <div className="course-management">
            <h1>مدیریت دوره‌ها</h1>
            <div className="course-management-actions">
                <Link to="list" className="course-management-button">
                    لیست دوره‌ها
                </Link>
                <Link to="add" className="course-management-button">
                    افزودن دوره جدید
                </Link>
                <Link to="all-buyers" className="course-management-button">
                    لیست خریداران همه دوره‌ها
                </Link>
            </div>
            <div className="course-management-content">
                <Outlet />
            </div>
        </div>
    );
};

export default CourseManagement;
